import React from 'react';
import { getPackstationInfo, isPackstation } from '../../utils/dhlValidation';

// SHI-627 — compact Packstation marker for the shipment-label tables. Renders nothing
// for a normal street address, so non-Packstation rows look exactly as before.
const BADGE = 't-inline-block t-rounded t-border t-px-1.5 t-py-0.5 t-text-xs t-font-medium t-whitespace-nowrap';
const OK = `${BADGE} t-border-gray-300 t-bg-gray-50 t-text-gray-700`;
const MISSING = `${BADGE} t-border-red-300 t-bg-red-50 t-text-red-700`;

const PackstationBadges = ({ consignee }) => {
  if (!isPackstation(consignee)) return null;
  const { lockerID, postNumber } = getPackstationInfo(consignee);
  return (
    <div className="t-flex t-flex-wrap t-gap-1 t-mt-1">
      {lockerID ? (
        <span className={OK}>Packstation {lockerID}</span>
      ) : (
        <span className={MISSING}>Locker number missing</span>
      )}
      {postNumber ? (
        <span className={OK}>Postnummer {postNumber}</span>
      ) : (
        <span className={MISSING}>Postnummer missing</span>
      )}
    </div>
  );
};

export default PackstationBadges;
